import React, { useCallback, useEffect, useMemo, useState } from "react";
import { useParams } from "react-router-dom";

import { feedback } from "../../shared/events";
import { schemaBuilder } from "../../shared/services";
import { ApiException } from "../../shared/services/api/ApiException";
import {
  IDetalhePerfis,
  IFuncionalidade,
  IOperacao,
  IProduto,
  PermissoesService,
} from "../../shared/services/api/permissoes/PermissoesService";
import { IVFormErros, useVFormRef } from "../../shared/forms";
import { AccordionNomePerfil } from "./componentes/AccordionNomePerfil";
import { AccordionPermissoes } from "./componentes/AccordionPermissoes";
import { changeBreadcrumbs, changeTitle } from "../../shared/events";
import { useTemPermissao } from "../../shared/contexts/PerfilDeUsuarioContext";
import { ConfirmNavigationHook } from "@gvdasa/components-confirm";
import {
  AppBar,
  Box,
  Button,
  FormControl,
  Grid,
  Toolbar,
  FooterActions,
  FooterAction,
} from "@gvdasa/react-components";

const formValidationShema: schemaBuilder.SchemaOf<IDetalhePerfis | any> =
  schemaBuilder.object().shape({
    Id: schemaBuilder.number().notRequired(),
    Nome: schemaBuilder.string().trim().required(),
  });

export const DetalhePermissoesPage: React.FC = () => {
  const { id = "novo" } = useParams<"id">();
  const formRef = useVFormRef();

  const [isLoading, setIsLoading] = useState(true);
  const [produtos, setProdutos] = useState<IProduto[]>([]);

  const [Nome, setNome] = useState<string>("");
  const [erroPerfil, setErroPerfil] = useState<boolean>(false);
  const [textoDeErroNome, setTextoDeErroNome] = useState("");

  const [erroAoSalvarPermissoes, setErroAoSalvarPermissoes] =
    useState<boolean>(false);
  const [mensagemDeErroPermissoes, setMensagemDeErroPermissoes] = useState("");

  const [pesquisar, setPesquisar] = useState<string>("");
  const filtrosPorOperacao = produtos.flatMap((pr) =>
    pr.modulos.flatMap((m) =>
      m.funcionalidades.flatMap((f) =>
        f.operacoes.filter((op) =>
          op.nome.toLowerCase().startsWith(pesquisar.toLowerCase())
        )
      )
    )
  );
  const [filtrado, setFiltrado] = useState(false);

  const gvConfirmation = useMemo(() => new ConfirmNavigationHook(), []);

  useEffect(() => {
    gvConfirmation.componentDidMount();

    return () => {
      gvConfirmation.componentWillUnmount();
    };
  }, [gvConfirmation]);

  useEffect(() => {
    changeTitle("Cadastrar permissões");
    changeBreadcrumbs([
      {
        id: "listagem-de-perfis",
        label: "Perfis ",
        path: "/login-service/perfis",
      },
      {
        id: "cadastrar-permissoes",
        label: "Cadastrar permissões",
        path: "/permissoes/detalhe/novo",
      },
    ]);
    return () => {
      changeTitle("");
      changeBreadcrumbs([]);
    };
  }, []);

  const permitirGerenciarPermissoes = useTemPermissao(
    "login-service.geral.perfil.gerenciar-permissoes"
  );
  const permitirIncluirPerfil = useTemPermissao(
    "login-service.geral.perfil.incluir"
  );
  const permitirEditarPerfil = useTemPermissao(
    "login-service.geral.perfil.editar"
  );

  useEffect(() => {
    setIsLoading(true);
    if (id === "novo") {
      PermissoesService.getPermissoes(0).then((data) => {
        if (data instanceof ApiException) {
          setIsLoading(true);
          feedback(data.message, "error");
        } else {
          setIsLoading(false);
          setProdutos(data.data);
          const dados = data.data.map((e) => e.modulos);
          const funcionalidades = dados.flatMap((e) =>
            e.flatMap((d) => d.funcionalidades)
          );
          const listaDePermissoesTrue: string[] = [];
          funcionalidades.map((item) => {
            item.operacoes.map((operacao) => {
              if (operacao.temPermissao === true) {
                listaDePermissoesTrue.push(`${item.id}${operacao.id}`);
              }
            });
          });
        }
      });
    } else {
      setIsLoading(true);
      PermissoesService.getPerfisById(id).then((data) => {
        setIsLoading(false);
        if (data instanceof ApiException) {
          feedback(data.message, "error");
          setIsLoading(true);
          setErroPerfil(true);
        } else {
          setIsLoading(true);
          setErroPerfil(false);
          setNome(data.Nome);
          PermissoesService.getPermissoes(id).then((data) => {
            if (data instanceof ApiException) {
              feedback(data.message, "error");
            } else {
              setIsLoading(false);
              setProdutos(data.data);
              const dados = data.data.map((e) => e.modulos);
              const funcionalidades = dados.flatMap((e) =>
                e.flatMap((d) => d.funcionalidades)
              );
              const listaDePermissoesTrue: string[] = [];
              funcionalidades.map((item) => {
                item.operacoes.map((operacao) => {
                  if (operacao.temPermissao === true) {
                    listaDePermissoesTrue.push(`${item.id}${operacao.id}`);
                  }
                });
              });
            }
          });
        }
      });
    }
    return () => {
      setIsLoading(false);
    };
  }, [id]);

  useEffect(() => {
    if (pesquisar.length > 0) {
      setFiltrado(true);
    }
    if (pesquisar.length === 0) {
      setFiltrado(false);
    }
  }, [pesquisar]);

  const handleMarcarTodos = (
    e: React.ChangeEvent<HTMLInputElement>,
    modulo: {
      id: string;
      nome: string;
      funcionalidades: IFuncionalidade[];
    },
    produto: IProduto
  ) => {
    const indeterminate = e.target.attributes[2].nodeValue;
    const lista = produto.modulos.flatMap((m) =>
      m.funcionalidades.flatMap((f) =>
        f.operacoes.filter(
          (op) =>
            op.temPermissao === true &&
            op.nome.toLowerCase().startsWith(pesquisar.toLowerCase())
        )
      )
    );

    if (e.target.checked === true) {
      {
        modulo.funcionalidades.flatMap((f) =>
          f.operacoes.flatMap((op) => {
            filtrosPorOperacao.flatMap((fo) => {
              if (fo === op) {
                op.temPermissao = true;
              }
            });
          })
        );
      }
    }
    if (e.target.checked === false) {
      modulo.funcionalidades.flatMap((f) =>
        f.operacoes.flatMap((op) => {
          filtrosPorOperacao.flatMap((fo) => {
            if (fo === op) {
              op.temPermissao = false;
            }
          });
        })
      );
    }
    if (e.target.checked === true && indeterminate === "true") {
      const listaOperacoes = produto.modulos.flatMap((m) =>
        m.funcionalidades.flatMap((f) =>
          f.operacoes.filter((o) =>
            o.nome.toLowerCase().startsWith(pesquisar.toLowerCase())
          )
        )
      );
      const listaTrue = lista.filter((t) => t.temPermissao === true);
      const listaFalse = lista.filter((t) => t.temPermissao === false);
      listaOperacoes.flatMap((l) => {
        listaTrue.length > listaFalse.length
          ? (l.temPermissao = false)
          : (l.temPermissao = true);
      });
    }
  };

  const handleValoresCheckbox = (
    event: any,
    data: IFuncionalidade,
    idOperacao: string
  ) => {
    const operacoes: IOperacao[] = data.operacoes;
    operacoes?.map((operacao) => {
      if (operacao.id === idOperacao && event.target.checked === true) {
        operacao.temPermissao = true;
      }
      if (operacao.id === idOperacao && event.target.checked === false) {
        operacao.temPermissao = false;
      }
    });
  };

  const handleSubmit = useCallback(() => {
    feedback("Salvando...", "info");

    formValidationShema
      .validate({ id, Nome }, { abortEarly: false })
      .then((dadosValidados: any) => {
        if (!dadosValidados) {
          feedback("Campos inválidos.", "error");
          return;
        }
        if (id === "novo") {
          PermissoesService.createPerfis(dadosValidados).then((result) => {
            if (result instanceof ApiException) {
              feedback(result.message, "error");
              setErroPerfil(true);
              setTextoDeErroNome(result.message);
            } else {
              setErroPerfil(false);
              feedback("Salvo com sucesso!", "success");
              PermissoesService.createPermissoes({
                idPerfil: result.Id,
                produtos: produtos,
              }).then((data) => {
                if (data instanceof ApiException) {
                  feedback(data.message, "error");
                  setErroAoSalvarPermissoes(true);
                  setMensagemDeErroPermissoes(data.message);
                } else {
                  setErroAoSalvarPermissoes(false);
                  singleSpaNavigate("/login-service/perfis");
                }
              });
            }
          });
        } else {
          PermissoesService.updatePerfisById(id, dadosValidados).then(
            (result) => {
              if (result instanceof ApiException) {
                feedback(result.message, "error");
                setErroPerfil(true);
                setTextoDeErroNome(result.message);
              } else {
                setErroPerfil(false);
                feedback(" Perfil salvo com sucesso!", "success");
                PermissoesService.createPermissoes({
                  idPerfil: id,
                  produtos: produtos,
                }).then((result) => {
                  if (result instanceof ApiException) {
                    feedback(result.message, "error");
                    setErroAoSalvarPermissoes(true);
                    setMensagemDeErroPermissoes(result.message);
                  } else {
                    setErroAoSalvarPermissoes(false);
                    singleSpaNavigate("/login-service/perfis");
                  }
                });
              }
            }
          );
        }
      })
      .catch((err: schemaBuilder.ValidationError) => {
        feedback("Campos inválidos.", "error");
        const validationErrors: IVFormErros = {};

        err.inner.forEach((error: any) => {
          if (!error.path) return;
          validationErrors[error.path] = error.message;
          setErroPerfil(true);
          setTextoDeErroNome(error.message);
        });
        formRef.current?.setErrors(validationErrors);
      });
  }, [formRef, id, Nome, produtos]);

  return (
    <Box
      display="flex"
      gap={4}
      flexDirection="column"
      marginBottom={10}
      height="auto"
    >
      <Grid container spacing={2} alignItems="baseline">
        <Grid size={12}>
          <FormControl
            data-testid="teste-accordion-nome"
            required
            margin="none"
            fullWidth
          >
            <AccordionNomePerfil
              disabled={
                id === "novo" ? permitirIncluirPerfil : permitirEditarPerfil
              }
              Nome={Nome}
              isLoading={isLoading}
              setNome={setNome}
              textoDeErroNome={textoDeErroNome}
              erroPerfil={erroPerfil}
            />
          </FormControl>
        </Grid>
        <Grid size={12}>
          <FormControl
            margin="none"
            data-testid="teste-accordion-produtos"
            fullWidth
            error={erroAoSalvarPermissoes}
          >
            <AccordionPermissoes
              disabled={permitirGerenciarPermissoes}
              isLoading={isLoading}
              produtos={produtos}
              erroAoSalvarPermissoes={erroAoSalvarPermissoes}
              handleValoresCheckbox={handleValoresCheckbox}
              mensagemDeErroPermissoes={mensagemDeErroPermissoes}
              handleMarcarTodos={handleMarcarTodos}
              pesquisar={pesquisar}
              setPesquisar={setPesquisar}
              filtrosPorOperacao={filtrosPorOperacao}
              setFiltrado={setFiltrado}
              filtrado={filtrado}
            />
          </FormControl>
        </Grid>
      </Grid>
      <FooterActions>
        <FooterAction
          id="gv-navigate"
          variant="outlined"
          size="medium"
          type="button"
          onClick={() => singleSpaNavigate('/login-service/perfis')}
        >
          Voltar
        </FooterAction>
        <FooterAction
          variant="contained"
          type="submit"
          size="medium"
          onClick={() => {
            handleSubmit();
          }}
        >
          Salvar e voltar
        </FooterAction>
      </FooterActions>
    </Box>
  );
};
